import React from 'react'

const QualityOfCare = ({ widgetUtilities, ...props }) => {
    // let DropDowns = useSelector(state => state.GeneralDropDownsReducer);

    const { 
        // initialDataPatientName, initialDataAge, initialDataDOB, initialDataAddress, initialDataMobileNumber, initialDataEmail, 
        // additionalInfoData, setAdditionalInfoData,
        // AddDocument,
        // setSaveDocumentData
        // handleDocumentDelete
        qualityOfCareData,
        setQualityOfCareData,
        setSaveQualityOfCareData
    } = widgetUtilities;

    const handleQualityOfCare = (e) => {
        let { name } = e.target;
        setQualityOfCareData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));

        setSaveQualityOfCareData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }
  return (
        <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='bg_yellow p-2 w-100'>
            <p className='heading font-b fs-13 mb-1 leter-spacing'>Quality of Care</p>
            <div className="ar_content">
                <div className="d-flex gap-40 align-items-center">

                    <div className="d-flex flex-column gap-2">

                        <label className="d-flex align-items-center gap-6">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    name="SummaryOfCareSent"
                                    checked={qualityOfCareData?.SummaryOfCareSent === "true"}
                                    onChange={handleQualityOfCare}
                                />
                            </div>
                            <p className="text">Summary of care sent</p>
                        </label>

                        <label className="d-flex align-items-center gap-6">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    name="IncomingTransferOfPatient"
                                    checked={qualityOfCareData?.IncomingTransferOfPatient === "true"}
                                    onChange={handleQualityOfCare}
                                />
                            </div>
                            <p className="text">Incoming transfer of care</p>
                        </label>

                        <label className="d-flex align-items-center gap-6">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    name="OutgoingTransferOfCare"
                                    checked={qualityOfCareData?.OutgoingTransferOfCare === "true"}
                                    onChange={handleQualityOfCare}
                                />
                            </div>
                            <p className="text">Outgoing transfer of care</p>
                        </label>
                    </div>
                    <div className="d-flex flex-column gap-2">
                        <label className="d-flex align-items-center gap-6">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    name="EducationMaterialGiven"
                                    checked={qualityOfCareData?.EducationMaterialGiven === "true"}
                                    onChange={handleQualityOfCare}
                                />
                            </div>
                            <p className="text">Education material given</p>
                        </label>
                        <label className="d-flex align-items-center gap-6">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    name="PatientDeclinedSummary"
                                    checked={qualityOfCareData?.PatientDeclinedSummary === "true"}
                                    onChange={handleQualityOfCare}
                                />
                            </div>
                            <p className="text">Patient declined summary</p>
                        </label>
                        <label className="d-flex align-items-center gap-6">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    name="VirtualVisit"
                                    checked={qualityOfCareData?.VirtualVisit === "true"}
                                    onChange={handleQualityOfCare}
                                />
                            </div>
                            <p className="text">Virtual visit</p>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        </div>
  )
}

export default QualityOfCare